import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { endpoints } from '../../utils/constants';
import axios from 'axios';

export const validateReferral = createAsyncThunk(
  'referral/validate',
  async (body, { rejectWithValue }) => {
    try {
      const params = { ...body };
      const response = await axios.get(endpoints.VALIDATE_REFERRAL, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Error desconocido' });
    }
  },
);

export const endReferralProcess = createAsyncThunk(
  'referral/endReferralProcess',
  async (requestBody, { rejectWithValue }) => {
    try {
      const response = await axios.post(endpoints.END_REFERRAL_PROCESS, requestBody);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Error desconocido' });
    }
  },
);

export const validateIdu = createAsyncThunk(
  'referral/validateIdu',
  async (idu, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${endpoints.VALIDATE_IDU}/${idu}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Error desconocido' });
    }
  },
);

export const INITIAL_ADDRESS = {
  address: '',
  floor: '',
  apartment: '',
  tower: '',
  additionalNotes: '',
  hasCoverage: false,
  isBuilding: false,
};

const INITIAL_PERSONAL_DATA = {
  name: '',
  lastname: '',
  documentType: '',
  documentNumber: '',
  cellularNumber: '',
  email: '',
};

const initialState = {
  address: INITIAL_ADDRESS,
  personalData: INITIAL_PERSONAL_DATA,
  referralIdu: '',
  mapData: null,
  loading: false,
  processId: ''
};

const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setReferralAddress: (state, action) => {
      state.address = { ...state.address, ...action.payload };
    },
    setReferralPersonalData: (state, action) => {
      state.personalData = { ...state.personalData, ...action.payload };
    },
    resetReferralState: (state) => {
      state.address = INITIAL_ADDRESS;
      state.personalData = INITIAL_PERSONAL_DATA;
      state.referralIdu = '';
      state.loading = false;
      state.mapData = null;
      state.processId = '';
    },
    setHasAddressCoverage: (state, action) => {
      state.address.hasCoverage = action.payload;
    },
    setIsBuilding: (state, action) => {
      state.address.isBuilding = action.payload;
    },
    setReferralIdu: (state, action) => {
      state.referralIdu = action.payload;
    },
    setMapData: (state, action) => {
      state.mapData = action.payload;
    },
    setProcessId: (state, action) => {
      state.processId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateReferral.pending, (state) => {
        state.loading = true;
      })
      .addCase(validateReferral.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(validateReferral.rejected, (state) => {
        state.loading = false;
      })
      .addCase(endReferralProcess.pending, (state) => {
        state.loading = true;
      })
      .addCase(endReferralProcess.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(endReferralProcess.rejected, (state) => {
        state.loading = false;
      })
      .addCase(validateIdu.pending, (state) => {
        state.loading = true;
      })
      .addCase(validateIdu.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(validateIdu.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setReferralAddress,
  setReferralPersonalData,
  resetReferralState,
  setHasAddressCoverage,
  setIsBuilding,
  setReferralIdu,
  setMapData,
  setProcessId
} = referralSlice.actions;

export default referralSlice.reducer;
